import React from 'react';
import ReactDOM from 'react-dom';
import VehicleTitle from './VehicleTitle';
import propDefs from '../proptypes';
import { remapPrefs } from '../utils/utility';

const VehicleTitleSidebar = ({ title, vehicle, prefs }) => {
	const [container] = document.querySelectorAll('.ddc-vehicle-title-sidebar');
	const sidebarPrefs = remapPrefs(prefs, '-sidebar');

	return ReactDOM.createPortal(
		<VehicleTitle title={title} vehicle={vehicle} prefs={sidebarPrefs} />,
		container
	);
};

VehicleTitleSidebar.propTypes = {
	title: propDefs.settings.title,
	vehicle: propDefs.settings.vehicle,
	prefs: propDefs.settings.prefs.isRequired
};

VehicleTitleSidebar.defaultProps = {
	title: propDefs.defaults.title,
	vehicle: propDefs.defaults.vehicle
};

export default VehicleTitleSidebar;
